import { NavLink } from '@tov-plus/frontend-data';
import { StatePanel } from '../components/StatePanel';
import { useGuestAccess } from '../contexts/GuestAccessContext';
import { msg, TovCard } from '@tov-plus/ui';
export function FollowUpPage() {
  const access = useGuestAccess();
  if (access.status !== 'ready') {
    return <StatePanel preset="loading" />;
  }
  const followUpSections = access.experience.guestWebsite.sections.filter(
    (section) =>
      section.enabled &&
      [
        'gallery_preview',
        'guestbook',
        'custom_content',
        'important_notes',
      ].includes(section.type),
  );
  return (
    <div className="page-grid">
      <TovCard variant="content" isWide className="hero-card">
        <p className="page-eyebrow">
          {msg('pages.home_page.pages_home_page_post_event_follow_up')}
        </p>
        <h2>
          {msg(
            'pages.follow_up_page.pages_follow_up_page_thank_yous_notes_and_shared_memories',
          )}
        </h2>
        <div className="action-row">
          <NavLink className="primary-button" to="/gallery">
            {`${msg('general.actions.open')} ${msg('general.modules.gallery.name')}`}{' '}
          </NavLink>
          <NavLink className="secondary-link" to="/messages">
            {msg(
              'pages.follow_up_page.pages_follow_up_page_review_follow_up_messages',
            )}{' '}
          </NavLink>
          <NavLink className="secondary-link" to="/registry">
            {msg(
              'pages.follow_up_page.pages_follow_up_page_registry_and_gifting',
            )}{' '}
          </NavLink>
        </div>
      </TovCard>

      <TovCard variant="content" isWide>
        <p className="page-eyebrow">
          {msg(
            'pages.follow_up_page.pages_follow_up_page_host_authored_follow_up',
          )}
        </p>
        {followUpSections.length > 0 ? (
          <div className="detail-list detail-list--stacked">
            {followUpSections.map((section) => (
              <article key={section.id}>
                <strong>
                  {typeof section.content_payload.post_event_headline ===
                  'string'
                    ? section.content_payload.post_event_headline
                    : typeof section.content_payload.title === 'string'
                      ? section.content_payload.title
                      : (section.anchor_label ?? section.section_key)}
                </strong>
                <span>
                  {typeof section.content_payload.post_event_summary ===
                  'string'
                    ? section.content_payload.post_event_summary
                    : typeof section.content_payload.body === 'string'
                      ? section.content_payload.body
                      : typeof section.content_payload.summary === 'string'
                        ? section.content_payload.summary
                        : msg(
                            'pages.follow_up_page.pages_follow_up_page_a_follow_up_note_was_published_for_guests',
                          )}
                </span>
                {typeof section.content_payload.post_event_cta_label ===
                'string' ? (
                  <span>
                    {msg(
                      'pages.follow_up_page.pages_follow_up_page_next_action',
                    )}{' '}
                    {section.content_payload.post_event_cta_label}
                    {typeof section.content_payload.post_event_cta_target ===
                    'string'
                      ? ` → ${section.content_payload.post_event_cta_target}`
                      : ''}
                  </span>
                ) : null}
              </article>
            ))}
          </div>
        ) : (
          <p>
            {msg(
              'pages.follow_up_page.pages_follow_up_page_no_host_authored_follow_up_sections_are_published',
            )}
          </p>
        )}
      </TovCard>

      <TovCard variant="content">
        <p className="page-eyebrow">
          {msg(
            'pages.follow_up_page.pages_follow_up_page_recommended_next_actions',
          )}
        </p>
        <div className="detail-list">
          <article>
            <strong>
              {msg('pages.follow_up_page.pages_follow_up_page_gallery_return')}
            </strong>
            <span>
              {msg(
                'pages.follow_up_page.pages_follow_up_page_share_or_review_approved_memories_without_reopening_the',
              )}{' '}
            </span>
          </article>
          <article>
            <strong>{msg('general.modules.messages.name')}</strong>
            <span>
              {msg(
                'pages.follow_up_page.pages_follow_up_page_check_for_thank_you_notes_late_updates_or',
              )}{' '}
            </span>
          </article>
          <article>
            <strong>
              {msg(
                'pages.follow_up_page.pages_follow_up_page_invite_continuity',
              )}
            </strong>
            <span>
              {msg(
                'pages.follow_up_page.pages_follow_up_page_your_invite_remains_the_same_occasion_scoped_path',
              )}{' '}
            </span>
          </article>
        </div>
      </TovCard>
    </div>
  );
}
